import './styles/main.scss';
import { initRsvpForm } from './rsvp-form';
import { initAccordions } from './accordion';
import { initPhotoUpload } from './photo-upload';

// Mobile navigation toggle
function initMobileNav(): void {
  const navToggle = document.querySelector('.nav-toggle');
  const navMobile = document.querySelector('.nav-mobile');

  if (!navToggle || !navMobile) return;

  navToggle.addEventListener('click', () => {
    const isOpen = navToggle.classList.toggle('nav-toggle--active');
    navMobile.classList.toggle('nav-mobile--open');
    navToggle.setAttribute('aria-expanded', isOpen.toString());

    // When opening, focus first link; when closing, return focus to toggle
    if (isOpen) {
      const firstLink = navMobile.querySelector('.nav__link') as HTMLElement;
      if (firstLink) firstLink.focus();
    }
  });

  // Close mobile nav when clicking a link
  navMobile.querySelectorAll('.nav__link').forEach((link) => {
    link.addEventListener('click', () => {
      navToggle.classList.remove('nav-toggle--active');
      navMobile.classList.remove('nav-mobile--open');
      navToggle.setAttribute('aria-expanded', 'false');
    });
  });
}

// Forgot password toggle on RSVP login page
function initForgotPasswordToggle(): void {
  const toggleButton = document.getElementById('forgot-password-toggle');
  const section = document.getElementById('forgot-password-section');

  if (!toggleButton || !section) return;

  // If there's a message displayed, show the section and scroll to it
  const hasMessage = section.querySelector('.form-message') !== null;
  if (hasMessage) {
    section.style.display = 'block';
    section.setAttribute('aria-hidden', 'false');
    toggleButton.setAttribute('aria-expanded', 'true');
    toggleButton.textContent = 'Hide password recovery';
    // Scroll to the section after a brief delay to ensure layout is complete
    setTimeout(() => {
      section.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 100);
  }

  toggleButton.addEventListener('click', () => {
    const isHidden = section.style.display === 'none';
    section.style.display = isHidden ? 'block' : 'none';
    section.setAttribute('aria-hidden', isHidden ? 'false' : 'true');
    toggleButton.setAttribute('aria-expanded', isHidden.toString());
    toggleButton.textContent = isHidden ? 'Hide password recovery' : 'Forgot your password?';
  });
}

// Main entry point
document.addEventListener('DOMContentLoaded', () => {
  console.log('Wedding site loaded');

  // Initialize mobile navigation
  initMobileNav();

  // Initialize forgot password toggle on login page
  initForgotPasswordToggle();

  // Initialize FAQ accordions, opening any question the URL links to
  initAccordions();

  // Initialize RSVP form/dashboard if on RSVP page
  if (document.querySelector('.rsvp-dashboard') || document.getElementById('rsvp-form')) {
    initRsvpForm();
  }

  // Initialize the guest photo upload form if on the photo upload page
  initPhotoUpload();
});
